import {
  Component,
  effect,
  inject,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PanelHeader } from '@layout/panel-header/panel-header';
import { Sidebar } from '@layout/sidebar/sidebar';
import { AppService } from '@shared/services/app.service';
import { PrintJobListenerService } from '@shared/services/websocket/print-job-listener.service';
import { SucursalService } from '@shared/services/sucursal.service';
import { EmpresaApiService } from '@core/services/api/empresa-api.service';
import { EmpresaService } from '@shared/services/empresa.service';
import { PermisoService } from '@shared/services/permiso.service';
import { PermisoApiService } from '@core/services/api/permiso-api.service';
import { SucursalListenerService } from '@shared/services/websocket/sucursal-listener.service';
import { SessionRevokedListenerService } from '@shared/services/websocket/session-revoked-listener.service';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { DeviceService } from '@shared/services/device.service';

@Component({
  selector: 'app-panel',
  imports: [RouterOutlet, Sidebar, PanelHeader],
  templateUrl: './panel.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './panel.css',
})
export class Panel implements OnDestroy, OnInit {
  private readonly printJobListener = inject(PrintJobListenerService);
  private readonly sucursalListener = inject(SucursalListenerService);
  private readonly sessionRevokedListener = inject(SessionRevokedListenerService);

  private readonly appService = inject(AppService);
  private readonly sucursalService = inject(SucursalService);

  private readonly empresaApiService = inject(EmpresaApiService);
  private readonly empresaService = inject(EmpresaService);

  private readonly permisoService = inject(PermisoService);
  private readonly permisoApiService = inject(PermisoApiService);

  private readonly localStorageService = inject(LocalStorageService);
  private readonly deviceService = inject(DeviceService);

  constructor() {
    this.sessionRevokedListener.start();
    effect(() => {
      if (this.appService.authReady() && this.sucursalService.sucursalReady()) {
        const sucursalId = this.sucursalService.activeSucursal()?.id;
        if (sucursalId) {
          this.printJobListener.start(sucursalId);
          this.sucursalListener.start(sucursalId);
        }
      }
      if (this.deviceService.isBrowser()) {
        this.localStorageService.loadConfig();
      }
    });
  }
  ngOnInit(): void {
    this.empresaApiService.cargarEmpresa().subscribe({
      next: (empresa) => {
        this.empresaService.setEmpresaData(empresa);
      },
    });

    // cargamos los permisos del usuario al iniciar el panel para tenerlos disponibles en toda la aplicación
    this.permisoApiService.cargarPermisos().subscribe({
      next: (permisos) => {
        this.permisoService.setPermisos(permisos);
      },
    });
  }
  ngOnDestroy(): void {
    this.sessionRevokedListener.stop();
    this.printJobListener.stop();

    const sucursalId = this.sucursalService.activeSucursal()?.id;
    if (sucursalId) {
      this.sucursalListener.stop(sucursalId);
    }
  }
}
